import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=aa1df9a4&scoped=true&"
import script from "./PriceCard.vue?vue&type=script&lang=js&"
export * from "./PriceCard.vue?vue&type=script&lang=js&"
import style0 from "./PriceCard.vue?vue&type=style&index=0&id=aa1df9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1df9a4",
  null
  
)

export default component.exports